export default __webpack_public_path__ + "static/media/yuryu-10.9fa2d413.svg";